module.exports = __webpack_public_path__ + "static/media/lamp.707353a1.png";